import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack, Button } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useToggle } from '../../../../hooks/use-toggle';
import { VyIcon } from '@vy/ui-design-system';
import { formatDate } from '../../../../utils/date';
import { LightInvoiceTitleDisplay } from '../light-invoice-components/LightInvoiceTitleDisplay';

type LightInvoiceContactDetailsProps = {
  contractName: string;
  startDate: Date;
  contractId: string;
};

export const LightInvoiceContactDetails: React.FC<LightInvoiceContactDetailsProps> = ({
  contractName,
  startDate,
  contractId,
}) => {
  const [expanded, toggleExpanded] = useToggle(true);
  const contractStartDate = formatDate(startDate);

  return (
    <>
      <Accordion expanded={expanded} onChange={() => toggleExpanded()}>
        <AccordionSummary
          expandIcon={
            <VyIcon
              icon="ArrowDown"
              style={{
                color: '#323232',
              }}
            />
          }
          sx={{ p: 0, height: '34px', alignItems: 'center' }}
        >
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              gap: 1
            }}>
            <VyIcon icon="ContractDocumentPen" />
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 600,
                lineHeight: "24px"
              }}>
              Contract details
            </Typography>
          </Stack>
        </AccordionSummary>

        <AccordionDetails sx={{ p: 0 }}>
          <Stack
            spacing={2}
            sx={{
              mb: 1.5,
              mt: 1.5,
              minHeight: '100px'
            }}>
            <Stack direction="row" spacing={4}>
              <LightInvoiceTitleDisplay value={contractStartDate} title="Start Date" />
              <LightInvoiceTitleDisplay value={contractName} title="Contract name" />
            </Stack>

            <Button
              size="large"
              color="secondary"
              variant="contained"
              component={NavLink}
              to={`/plans/contracts/${contractId}`}
              sx={{
                padding: '8px 12px',
                width: 'fit-content',
              }}
              endIcon={<KeyboardArrowRightIcon />}
            >
              Go to contract
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
